import React, { Component } from 'react';
import mapboxgl from 'mapbox-gl';
import axios from 'axios';
import directionData from '../utils/Direction';


class MapDirection extends Component {
    constructor(props){
        super(props);
        this.searchSelected = 0;
    }
    searchHandler(e){
        this.listSelected = 0;
        let query = e.target.value,
            url = `http://nominatim.openstreetmap.org/search/${query}?format=json&addressdetails=1&limit=100&countrycodes=ae`;
        //let urls = `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json?country=ae&access_token=${mapboxgl.accessToken}`;

        if(!query){
            this.props.setLocation([]);
            if(this.props.map.getLayer('dir')){
                this.props.map.setLayoutProperty('dir', 'visibility' , 'none');
                this.props.map.setLayoutProperty('uaeu-start', 'visibility' , 'none');
                this.props.map.setLayoutProperty('uaeu-end', 'visibility' , 'none');
            }
            return false;
        }
        var instance = axios.create({
            baseURL: url,
          });
    
          axios.get(instance.defaults.baseURL)
          .then( (response) => {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' +
                  response.status);
                return;
              }

              this.props.setLocation(response.data);

          })
          .catch( (error) => {
              console.log(error);
          });  
    }

    renderDirection(e){
        let lat = e.target.getAttribute('data-lat'),
            lng = e.target.getAttribute('data-lon'),
            start = [lng,  lat],
            end = [55.67501705779756, 24.202561192217544],
            value = e.target.innerText,
            directionsRequest = 'https://api.mapbox.com/directions/v5/mapbox/driving/' + start[0] + ',' + start[1] + ';' + end[0] + ',' + end[1] + '?geometries=geojson&steps=true&access_token=' + mapboxgl.accessToken;
            //directionsRequest = 'http://router.project-osrm.org/route/v1/driving/' + start[0] + ',' + start[1] + ';' + end[0] + ',' + end[1] + '?overview=false&geometries=geojson&steps=true';
            
        this.listSelected = 0;
            
        this.props.map.flyTo({
            center: [55.678677781457054, 24.198490356012897],
            speed: 0.5,
            zoom: 8
        });

        
        axios.get(directionsRequest)
        .then( (response) => {
            var geometryArr = {
                coordinates: [],
                type: "LineString"
            }

            var route = response.data.routes[0].legs[0].steps;

            route.map((geometry)=>{
                geometry.geometry.coordinates.map((arr)=>{
                    geometryArr.coordinates.push(arr)
                });
            });

            directionData.directionLayer.source.data = geometryArr;
            directionData.locationMarkers.features[0].geometry.coordinates = start;
            directionData.locationMarkers.features[1].geometry.coordinates = end;


            if(!this.props.map.getLayer('dir')){
                this.props.map.addLayer(directionData.directionLayer);
                this.props.map.setLayoutProperty('dir', 'visibility' , 'visible');
            }else{
                this.props.map.getSource('dir').setData(geometryArr);
                this.props.map.setLayoutProperty('dir', 'visibility' , 'visible');
            }


            directionData.locationMarkers.features.map((marker, i) => {
                directionData.markerLayer.id = marker.properties.id;
                directionData.markerLayer.source.data = marker.geometry;

                if(!this.props.map.getLayer(marker.properties.id)){
                    this.props.map.addLayer(directionData.markerLayer);
                    this.props.map.setLayoutProperty(marker.properties.id, 'visibility' , 'visible');
                }else{
                    this.props.map.getSource(marker.properties.id).setData( directionData.markerLayer.source.data);
                    this.props.map.setLayoutProperty(marker.properties.id, 'visibility' , 'visible');
                }
            });

            this.props.setLocation([]);
            document.getElementById('map-direction-search').value = value
        })
        .catch((error) => {
            console.log(error); 
        });
    }

    handleKeyPress(e){
        
        let item = document.querySelectorAll('.map-direction-item'),
            scrollElem = document.getElementsByClassName('map-direction-list')[0];
        //this.props.setActiveFilter(true);
        if(item.length > 0){
            item.forEach((i)=>{
                i.classList.remove('direction-selected');
            });
        }
        if(e.keyCode === 40 && this.searchSelected <= item.length-1) {
            this.searchSelected += 1;
        }

        if(e.keyCode === 38 && this.searchSelected > 1) {
            this.searchSelected -= 1;
        }

        
        if(this.searchSelected > 0 && item.length> 0){

            item[this.searchSelected-1].classList.add('direction-selected');
            scrollElem.scrollTop = item[this.searchSelected-1].offsetTop;
            if(e.keyCode === 13){
                item[this.searchSelected-1].click();
                this.searchSelected = 0;
            }
        }
        
    }


    render(){
        let searchResult = this.props.locationList.map((data) => {
            return <div key={data.place_id} className="map-direction-item" data-lat={data.lat} data-lon={data.lon} onClick={this.renderDirection.bind(this)}>
                        <div className="direction-name" data-lat={data.lat} data-lon={data.lon}>{data.display_name}</div>
                        {/* <div className="direction-location" data-lat={data.lat} data-lon={data.lon}>{data.address.country}, {data.address.state}</div> */}
                    </div>;
            
        });

        return(
            <div className="map-direction">
                <div className="map-direction-inner">
                    <div className="map-direction-field">
                        <input placeholder="Choose Destination..." onChange={this.searchHandler.bind(this)} onKeyUp={this.handleKeyPress.bind(this)} id="map-direction-search" autoFocus/>
                    </div>
                    {/* <div className="map-direction-field">
                        <input value="UAEU Crescent Building" disabled/>
                    </div> */}
                    <div className="map-direction-list">
                        {searchResult}
                    </div>
                </div>
            </div>
        );
    }
}
export default MapDirection;


// WEBPACK FOOTER //
// ./src/components/MapDirection.js